module.exports = __webpack_public_path__ + "img/HongKongTrustSwper5.aee1da77.jpg";